module.exports = __webpack_public_path__ + "img/cover-product-te-hair.cdfeae32.jpg";